import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yyjc",
  "use": "icon-yyjc-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-yyjc\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 80a32 32 0 0 1 32 32v26.96h280.448c54.896 0 99.552 44.416 99.552 99.392V608.96c0 54.96-44.64 99.392-99.552 99.392H544v71.552l142.816 102.048a32 32 0 1 1-37.2 52.064L512 835.712l-137.616 98.32a32 32 0 1 1-37.216-52.064L480 779.92v-71.552H199.552c-54.896 0-99.552-44.432-99.552-99.392V238.352c0-54.976 44.64-99.392 99.552-99.392H480V112a32 32 0 0 1 32-32z m-312.448 122.96a35.472 35.472 0 0 0-35.552 35.392V608.96c0 19.472 15.84 35.392 35.552 35.392h624.896a35.472 35.472 0 0 0 35.552-35.392V238.352c0-19.472-15.84-35.392-35.552-35.392H199.552z m562.72 107.408a32 32 0 0 1 4.688 45.024l-127.456 156.96a32 32 0 0 1-39.168 8.432l-217.392-108.848-89.248 87.168a32 32 0 1 1-44.72-45.776l105.552-103.104a32 32 0 0 1 36.688-5.712l214.8 107.552 111.248-137.024a32 32 0 0 1 45.024-4.672z\" p-id=\"90745\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yyjc.svg
// module id = INL1
// module chunks = 22